import styled from "styled-components";

export const StyledWrapper = styled.div<{ sidebarWidth: number }>`
  width: calc(100% - ${(props) => props.sidebarWidth}px);
  height: 100%;

  .scrollbar {
    height: 100% !important;
  }
`;
